import React from 'react';
import LegalLayout from '../components/LegalLayout';

const CookiePolicy = () => (
  <LegalLayout title="Cookie Policy" lastUpdated="August 8, 2026">
    <p>
      This Cookie Policy explains how Create by Lumera ("we", "us") uses cookies and similar technologies on <strong>createbylumera.com</strong> (the "Service").
    </p>

    <h2>1. What Are Cookies?</h2>
    <p>
      Cookies are small text files placed on your device when you visit a website. They help websites function, remember your preferences, and provide analytics. Similar technologies include local storage, session storage, and tracking pixels.
    </p>

    <h2>2. Cookies We Use</h2>

    <h3>2.1 Essential Cookies</h3>
    <p>These cookies are necessary for the Service to function and cannot be disabled.</p>
    <ul>
      <li><strong>Authentication session</strong> (httpOnly cookie: <code>lumera_session</code>) — keeps you logged in securely across sessions. This cookie cannot be accessed by JavaScript.</li>
      <li><strong>Session management</strong> — maintains your active session state</li>
    </ul>

    <h3>2.2 Functional Cookies</h3>
    <p>These cookies remember your preferences to improve your experience.</p>
    <ul>
      <li><strong>Currency preference</strong> — remembers your selected currency (USD/NOK)</li>
      <li><strong>UI preferences</strong> — theme settings, collapsed sections, etc.</li>
    </ul>

    <h3>2.3 Third-Party Cookies</h3>
    <p>Some third-party services integrated into the Service may set their own cookies:</p>
    <ul>
      <li><strong>Stripe</strong> — may set cookies during the payment checkout flow for fraud prevention</li>
      <li><strong>PayPal</strong> — may set cookies during the PayPal payment flow</li>
    </ul>
    <p>We do not control these third-party cookies. Refer to their respective privacy policies for details.</p>

    <h2>3. Cookies We Do NOT Use</h2>
    <p>We want to be transparent about what we don't do:</p>
    <ul>
      <li>We do <strong>not</strong> use advertising or targeting cookies</li>
      <li>We do <strong>not</strong> use Google Analytics or similar tracking services</li>
      <li>We do <strong>not</strong> sell cookie data to third parties</li>
      <li>We do <strong>not</strong> use cross-site tracking</li>
    </ul>

    <h2>4. Managing Cookies</h2>
    <p>You can manage cookies through your browser settings:</p>
    <ul>
      <li><strong>Chrome:</strong> Settings → Privacy and Security → Cookies and other site data</li>
      <li><strong>Firefox:</strong> Settings → Privacy & Security → Cookies and Site Data</li>
      <li><strong>Safari:</strong> Preferences → Privacy → Manage Website Data</li>
      <li><strong>Edge:</strong> Settings → Cookies and site permissions</li>
    </ul>
    <p>Please note that blocking essential cookies may prevent the Service from functioning properly (e.g., you won't be able to stay logged in).</p>

    <h2>5. Local Storage</h2>
    <p>
      In addition to cookies, we use browser local storage to store your authentication token and certain UI preferences. Local storage persists until explicitly cleared by you or the application.
    </p>

    <h2>6. Updates to This Policy</h2>
    <p>
      We may update this Cookie Policy as our use of cookies evolves. Changes will be posted on this page with an updated "last updated" date.
    </p>

    <h2>7. Contact</h2>
    <p>Questions about our use of cookies? Contact us at <strong>support@createbylumera.com</strong>.</p>
  </LegalLayout>
);

export default CookiePolicy;
